export const categoryPanelProps = {
    linkType: {
        default: 'blog'
    },
    latest: {
        default: 'آخرین مطالب'
    }
}